import { MainPanelWrapper } from './MainPanelWrapper'

interface MainPanelLabelProps {
  children?: React.ReactNode
  muted?: boolean
}

export const MainPanelLabel = ({ children, muted }: MainPanelLabelProps) => {
  return (
    <MainPanelWrapper style={{ color: muted ? '#a7aabd' : '#5d6f8a' }}>
      {children}
    </MainPanelWrapper>
  )
}
